module.exports = __webpack_public_path__ + "img/member-1.89b788c2.png";